.subHeader {
  color: black;
  font-size: 13px;
}

.vouchersPanel {
  /*background: var(--color-cool-gray); */
  margin-top:calc(var(--spacing) * 2); 
  margin-left:calc(var(--spacing) * -3);
  width: calc(100% + (var(--spacing) * 6));
  padding: var(--spacing) calc(var(--spacing) * 3) calc(var(--spacing) * 2);
  border-radius: 0;
}

.dimmer {
  z-index: 2;
  margin-top: calc(var(--spacing) * -3);
  margin-left: calc(var(--spacing) * -3);
  position: absolute;
  width: 50%;
  height: 100%;
  background: rgba(0, 0, 0, .15);
}

.addPaymentPanel {
  position: relative;
  z-index:3;
  margin-left: calc(var(--spacing) * -3);
  padding-top: calc(var(--spacing));
  padding-bottom: calc(var(--spacing) * 2);
  width: calc(100% + ((var(--spacing) * 6)));
  background-color: white;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);
}

.addPaymentPanelTitle {
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  padding-left: calc(var(--spacing) * 4);
  margin-bottom: calc(var(--spacing) * 2);
  margin-top: calc(var(--spacing) * 2);
}

.addPaymentItem {
  padding-left: calc(var(--spacing) * 3);
  padding-right: calc(var(--spacing) * 3);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.4s;
  &:hover {
    transition: background-color 0.4s;
    background-color: rgba(0, 0, 0, .05);
  }
}

.addPaymentItemTitle {
  display: flex;
  align-items: center;
}

.icon {
  width: 44px;
}

.info {
  /*padding: var(--spacing) calc(var(--spacing) * 2);*/
}
.addButton {
  margin-top: calc(var(--spacing));
}
.info, .instructions {
  color: var(--color-black-50);
  font-size: 13px;

  /*padding: 0 calc(var(--spacing));*/

  & > a {
    color: var(--color-black-50);

    &:focus-visible {
      color: black;
      outline: none;
    }

    @media (--hover) {
      &:hover {
        color: black;
      }
    }
  }
}

.marginTop {
  margin-top: var(--spacing);
}

.message {
  padding: calc(var(--spacing) * 2) 0;
}

.panelPadding {
  padding: calc(var(--spacing) * 2);
}

.panelGray {
  background: var(--color-cool-gray); 
}

.button {
  color: var(--color-black-50);
  font-size: 13px;
  text-decoration: underline;

  &:focus-visible {
    color: black;
  }

  @media (--hover) {
    &:hover {
      color: black;
    }
  }
}






.wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 calc(var(--spacing) * 3) var(--spacing);
  gap: var(--spacing);
}

.title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: calc(var(--spacing) * 2);
}

